import { Component, Inject } from '@angular/core';
import { CORE_DIRECTIVES } from '@angular/common';
import { UserService, LoadingService } from '../services';

@Component({
    selector: 'usermgt',
    template: require('./usersync.html'),
    directives: [CORE_DIRECTIVES],
    providers: [UserService]
})
export class UserSyncComponent {
    success = false;

    constructor(
        private userSvc: UserService,
        protected loadingService: LoadingService
    ) {
        //
    }

    doSync() {
        this.loadingService.startLoad();
        this.success = false;

        this.userSvc.syncUsernames().subscribe(
            () => { this.success = true; },
            null,
            () => this.loadingService.stopLoad()
        );
    }
}


/** WEBPACK FOOTER **
 ** ./app/users/UserSyncComponent.ts
 **/